import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isVirginReservationSelector, isRestrictedReservationSelector } from 'selectors/customPathCheckInSelectors';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';

const { HOME_PAGE_URL, RESTRICTED_OCI_LANDING_PAGE, VIRGIN_OCI_LANDING_PAGE } = WINDOW_OBJECT_KEYS;

/**
 * useReservationRedirect - Set redirect depending if its virgin, restricted, or regular reservation
 * @return {string} redirect path
 */
const useReservationRedirect = () => {
  const isRestrictedReservation = useSelector(isRestrictedReservationSelector);
  const isVirginReservation = useSelector(isVirginReservationSelector);
  const [redirectPagePathName, setRedirectPagePathName] = useState();

  useEffect(
    () => {
      if (isVirginReservation) {
        setRedirectPagePathName(VIRGIN_OCI_LANDING_PAGE);
      } else if (isRestrictedReservation) {
        setRedirectPagePathName(RESTRICTED_OCI_LANDING_PAGE);
      } else {
        setRedirectPagePathName(HOME_PAGE_URL);
      }
    },
    [isVirginReservation, isRestrictedReservation]
  );

  return redirectPagePathName;
};

export default useReservationRedirect;
